import { CustoBudgetVersaoStatus } from '../generated/backend-enums.js';
export { CustoBudgetVersaoStatus };
export const CustoBudgetVersaoStatusMap = {
    [CustoBudgetVersaoStatus.RASCUNHO]: 'Rascunho',
    [CustoBudgetVersaoStatus.EM_APROVACAO]: 'Em Aprovação',
    [CustoBudgetVersaoStatus.APROVADO]: 'Aprovado',
    [CustoBudgetVersaoStatus.REPROVADO]: 'Reprovado',
};
